import React, { useState, useEffect, useRef } from "react";
import "./TestimonialSlider.css";

const TestimonialsContent =[
  {
    id: 1,
    name: "Ravi Sharma",
    designation: "UTS Member",
    feedback:
      "Harsh Bhagat sir ne trading ka pura nazariya badal diya. Pehle har candle ek guess lagti thi, ab har move ka logic samajh aata hai. Confidence itna aa gaya hai ki ab har trade ek plan ke saath hoti hai.",
  },
  {
    id: 2,
    name: "Ananya Singh",
    designation: "Trader",
    feedback:
      "Harsh sir ke sessions me ek alag energy hoti hai. Sirf strategy nahi, mindset sikhate hain. Pehle dar lagta tha loss se, ab har setup calmly handle karti hoon. Trading finally makes sense!",
  },
  {
    id: 3,
    name: "Arjun Patel",
    designation: "UTS 1.6 Student",
    feedback:
      "UTS join karne ke baad mera trading journey literally restart hua. H-Levels aur RSI concepts ne meri accuracy double kar di. Harsh sir ek teacher nahi, ek real market mentor hain.",
  },
  {
    id: 4,
    name: "Priya Mehta",
    designation: "Full-Time Trader",
    feedback:
      "Harsh Bhagat sir market ko emotion ke saath explain karte hain — that’s what makes him different. Sirf charts nahi, trading ka feel samjhte hain. UTS ne mujhe consistent bana diya.",
  },
  {
    id: 5,
    name: "Saurabh Jain",
    designation: "Community Member",
    feedback:
      "Main har baar market ko blame karta tha, par Harsh sir ne sikhaya ki galti strategy me nahi, soch me hoti hai. Ab har trade ek system se hoti hai. Harsh Bhagat sir ne trading ko discipline bana diya.",
  },
  {
    id: 6,
    name: "Neha Reddy",
    designation: "Student, Hyderabad",
    feedback:
      "Main strategies seekhne aayi thi, par Harsh Bhagat sir se self-belief seekh gayi. Sir ka har session ek push deta hai — market hi nahi, life me bhi better banne ka.",
  },
    {
    id: 1,
    name: "Ravi Sharma",
    designation: "UTS Member",
    feedback:
      "Harsh Bhagat sir ne trading ka pura nazariya badal diya. Pehle har candle ek guess lagti thi, ab har move ka logic samajh aata hai. Confidence itna aa gaya hai ki ab har trade ek plan ke saath hoti hai.",
  },
  {
    id: 2,
    name: "Ananya Singh",
    designation: "Trader",
    feedback:
      "Harsh sir ke sessions me ek alag energy hoti hai. Sirf strategy nahi, mindset sikhate hain. Pehle dar lagta tha loss se, ab har setup calmly handle karti hoon. Trading finally makes sense!",
  },
  {
    id: 3,
    name: "Arjun Patel",
    designation: "UTS 1.6 Student",
    feedback:
      "UTS join karne ke baad mera trading journey literally restart hua. H-Levels aur RSI concepts ne meri accuracy double kar di. Harsh sir ek teacher nahi, ek real market mentor hain.",
  },
  {
    id: 4,
    name: "Priya Mehta",
    designation: "Full-Time Trader",
    feedback:
      "Harsh Bhagat sir market ko emotion ke saath explain karte hain — that’s what makes him different. Sirf charts nahi, trading ka feel samjhte hain. UTS ne mujhe consistent bana diya.",
  },
  {
    id: 5,
    name: "Saurabh Jain",
    designation: "Community Member",
    feedback:
      "Main har baar market ko blame karta tha, par Harsh sir ne sikhaya ki galti strategy me nahi, soch me hoti hai. Ab har trade ek system se hoti hai. Harsh Bhagat sir ne trading ko discipline bana diya.",
  },
  {
    id: 6,
    name: "Neha Reddy",
    designation: "Student, Hyderabad",
    feedback:
      "Main strategies seekhne aayi thi, par Harsh Bhagat sir se self-belief seekh gayi. Sir ka har session ek push deta hai — market hi nahi, life me bhi better banne ka.",
  },
    {
    id: 1,
    name: "Ravi Sharma",
    designation: "UTS Member",
    feedback:
      "Harsh Bhagat sir ne trading ka pura nazariya badal diya. Pehle har candle ek guess lagti thi, ab har move ka logic samajh aata hai. Confidence itna aa gaya hai ki ab har trade ek plan ke saath hoti hai.",
  },
  {
    id: 2,
    name: "Ananya Singh",
    designation: "Trader",
    feedback:
      "Harsh sir ke sessions me ek alag energy hoti hai. Sirf strategy nahi, mindset sikhate hain. Pehle dar lagta tha loss se, ab har setup calmly handle karti hoon. Trading finally makes sense!",
  },
  {
    id: 3,
    name: "Arjun Patel",
    designation: "UTS 1.6 Student",
    feedback:
      "UTS join karne ke baad mera trading journey literally restart hua. H-Levels aur RSI concepts ne meri accuracy double kar di. Harsh sir ek teacher nahi, ek real market mentor hain.",
  },
  {
    id: 4,
    name: "Priya Mehta",
    designation: "Full-Time Trader",
    feedback:
      "Harsh Bhagat sir market ko emotion ke saath explain karte hain — that’s what makes him different. Sirf charts nahi, trading ka feel samjhte hain. UTS ne mujhe consistent bana diya.",
  },
  {
    id: 5,
    name: "Saurabh Jain",
    designation: "Community Member",
    feedback:
      "Main har baar market ko blame karta tha, par Harsh sir ne sikhaya ki galti strategy me nahi, soch me hoti hai. Ab har trade ek system se hoti hai. Harsh Bhagat sir ne trading ko discipline bana diya.",
  },
  {
    id: 6,
    name: "Neha Reddy",
    designation: "Student, Hyderabad",
    feedback:
      "Main strategies seekhne aayi thi, par Harsh Bhagat sir se self-belief seekh gayi. Sir ka har session ek push deta hai — market hi nahi, life me bhi better banne ka.",
  },
    {
    id: 1,
    name: "Ravi Sharma",
    designation: "UTS Member",
    feedback:
      "Harsh Bhagat sir ne trading ka pura nazariya badal diya. Pehle har candle ek guess lagti thi, ab har move ka logic samajh aata hai. Confidence itna aa gaya hai ki ab har trade ek plan ke saath hoti hai.",
  },
  {
    id: 2,
    name: "Ananya Singh",
    designation: "Trader",
    feedback:
      "Harsh sir ke sessions me ek alag energy hoti hai. Sirf strategy nahi, mindset sikhate hain. Pehle dar lagta tha loss se, ab har setup calmly handle karti hoon. Trading finally makes sense!",
  },
  {
    id: 3,
    name: "Arjun Patel",
    designation: "UTS 1.6 Student",
    feedback:
      "UTS join karne ke baad mera trading journey literally restart hua. H-Levels aur RSI concepts ne meri accuracy double kar di. Harsh sir ek teacher nahi, ek real market mentor hain.",
  },
  {
    id: 4,
    name: "Priya Mehta",
    designation: "Full-Time Trader",
    feedback:
      "Harsh Bhagat sir market ko emotion ke saath explain karte hain — that’s what makes him different. Sirf charts nahi, trading ka feel samjhte hain. UTS ne mujhe consistent bana diya.",
  },
  {
    id: 5,
    name: "Saurabh Jain",
    designation: "Community Member",
    feedback:
      "Main har baar market ko blame karta tha, par Harsh sir ne sikhaya ki galti strategy me nahi, soch me hoti hai. Ab har trade ek system se hoti hai. Harsh Bhagat sir ne trading ko discipline bana diya.",
  },
  {
    id: 6,
    name: "Neha Reddy",
    designation: "Student, Hyderabad",
    feedback:
      "Main strategies seekhne aayi thi, par Harsh Bhagat sir se self-belief seekh gayi. Sir ka har session ek push deta hai — market hi nahi, life me bhi better banne ka.",
  },
]

const TestimonialSlider = () => {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const sliderRef = useRef(null);

  // Create infinite loop by duplicating testimonials multiple times
  const testimonials = [
    ...TestimonialsContent,
    ...TestimonialsContent,
    ...TestimonialsContent
  ];

  // Auto-slide every 3s
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrent((prev) => {
      const next = prev + 1;
      
      // When we reach the end of the first set of testimonials,
      // smoothly transition and then reset to beginning without user noticing
      if (next >= TestimonialsContent.length) {
        // Use setTimeout to reset position after transition completes
        setTimeout(() => {
          setIsTransitioning(false);
          setCurrent(0); // Reset to start of original testimonials
        }, 300);
        return next;
      }
      
      return next;
    });
  };

  // Handle transition state
  useEffect(() => {
    if (current < TestimonialsContent.length) {
      setIsTransitioning(true);
    }
  }, [current]);

  return (
    <section className="testimonial-section">
      <div className="">
        <div className="testimonial-slider-container">
          <div
            ref={sliderRef}
            className="testimonial-slider-wrapper"
            style={{
              transform: `translateX(-${current * 100}%)`,
              transition: isTransitioning ? "transform 0.3s ease-in-out" : "none",
            }}
          >
            {testimonials.map((item, idx) => (
              <div className="testimonial-slide" key={`${item.id}-${idx}`}>
                <div className="testimonial-content">
                  <div className="testimonial-left">
                    {/* <div className="testimonial-avatar">
                      <div className="avatar-placeholder">
                        <span className="avatar-label">Avatar<br />112×112px</span>
                      </div>
                    </div> */}
                    <div className="testimonial-author">
                      <div className="author-name">{item.name}</div>
                      <div className="author-title">{item.designation}</div>
                    </div>
                  </div>
                  <div className="testimonial-right">
                    <blockquote className="testimonial-quote">
                      "{item.feedback}"
                    </blockquote>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;
